import React from 'react';

interface IIconUserGrowthDocsProps {
  className?: string;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
}

const IconUserGrowthDocs: React.FC<IIconUserGrowthDocsProps> = ({
  className,
  style,
  width = 124,
  height = 124,
}) => {
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="icon-user-growth-docs-svg-group">
        <rect
          x="101.949"
          y="26.522"
          width="8.61111"
          height="30.1389"
          rx="1.63611"
          transform="rotate(90 101.949 26.522)"
          fill="#E2E2E2"
        />
        <path
          d="M17.0382 90.0245L20.9511 93.6567C21.6134 94.2714 22.6486 94.2329 23.2633 93.5707L50.3291 64.4132C50.9439 63.751 51.9791 63.7125 52.6414 64.3272L62.8654 73.8178C63.5276 74.4326 64.5629 74.3941 65.1776 73.7318L99.5664 36.6854C100.181 36.0232 100.143 34.988 99.4804 34.3732L95.5675 30.741C94.9052 30.1263 93.87 30.1648 93.2553 30.827L64.7249 61.5623C64.1101 62.2245 63.0749 62.263 62.4127 61.6483L52.1886 52.1577C51.5264 51.5429 50.4912 51.5814 49.8764 52.2437L16.9522 87.7123C16.3375 88.3745 16.376 89.4097 17.0382 90.0245Z"
          fill="#E2E2E2"
        />
        <rect
          x="93.3398"
          y="26.522"
          width="8.61111"
          height="30.1389"
          rx="1.63611"
          fill="#E2E2E2"
        />
      </g>
      <circle cx="111.082"
        cy="75.9502"
        r="3.61667"
        fill="#0A0A0A"
        fillOpacity="0.05"
      />
      <circle cx="38.7497"
        cy="112.116"
        r="5.68333"
        fill="#0A0A0A"
        fillOpacity="0.05"
      />
      <circle cx="22.2185"
        cy="23.2502"
        r="5.68333"
        fill="#0A0A0A"
        fillOpacity="0.05"
      />
    </svg>
  );
};

export default IconUserGrowthDocs;